import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import { display, justifyContent, maxWidth, space } from 'styled-system';

interface EnergyLabelProps {
  url: string;
  alt: string;
  as?: string;
}

const MAX_WIDTH_S = '300px';
const MAX_WIDTH_M = '320px';
const MAX_WIDTH_XL = '290px';

const UnstyledLabelContainer = styled.div<any>`
  ${display};
  ${justifyContent};
  ${space};
`;

const LabelContainer = (props: ComponentProps<typeof UnstyledLabelContainer>) => (
  <UnstyledLabelContainer
    display="flex"
    justifyContent="center"
    py={['sp_0', 'sp_24']}
    {...props}
  />
);

const UnstyledImage = styled.img<any>`
  ${maxWidth};
`;

const Image = (props: ComponentProps<typeof UnstyledImage>) => (
  <UnstyledImage maxWidth={[MAX_WIDTH_S, MAX_WIDTH_M, null, MAX_WIDTH_XL]} {...props} />
);

const EnergyLabel = ({ url, alt, ...restProps }: EnergyLabelProps) => (
  <LabelContainer data-testid="energy-label" {...restProps}>
    <Image alt={alt || ''} src={url} />
  </LabelContainer>
);

export default EnergyLabel;
